import { API_URL } from "../Constants/ApiConstant";


export function AddCategory(callback, data) {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    fetch(`${API_URL}/add-category`,  {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({...data,role}),
        withCredentials: true,
    })
      .then(res => res.json())
      .then(callback)
      .catch((err) => callback({ error: true, message: err.message || 'Network error' }));
}



export function getCategoryHierarchy(callback) {
    const token = localStorage.getItem('token');
    fetch(`${API_URL}/get-category-hierarchy`,  {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
      .then(res => res.json())
      .then(callback)
      .catch((err) => callback({ error: true, message: err.message || 'Network error' }));
}

export function getCategoryById(callback, id) {
    const token = localStorage.getItem('token');
    fetch(`${API_URL}/get-category/${id}`,  {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
      .then(res => res.json())
      .then(callback)
      .catch((err) => callback({ error: true, message: err.message || 'Network error' }));
}

export function updateCategory(callback, data) {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    fetch(`${API_URL}/edit-category`,  {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({...data, role}),
    })
      .then(res => res.json())
      .then(callback)
      .catch((err) => callback({ error: true, message: err.message || 'Network error' }));
}

export function deleteCategory(callback, id) {
    const role = localStorage.getItem('role');
    const token = localStorage.getItem('token');
    fetch(`${API_URL}/delete-category`,  {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({id,role}),
    })
      .then(res => res.json())
      .then(callback)
      .catch((err) => callback({ error: true, message: err.message || 'Network error' }));
}